export default __webpack_public_path__ + "static/media/ftb.acd17596.svg";